// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'linkedin';

export const Component = () => (
  <path d='M5.98 3.347c0 .623-.239 1.198-.718 1.676-.527.432-1.102.67-1.82.67-.719 0-1.34-.238-1.772-.67C1.24 4.593 1 4.018 1 3.347c0-.719.24-1.293.67-1.724C2.102 1.19 2.676 1 3.49 1c.766 0 1.34.191 1.772.623.431.479.67 1.054.718 1.724Zm-.143 19.348H1.143V7.561h4.694v15.134Zm2.778-10.297c0-2.011-.048-3.64-.096-4.837h4.07l.24 2.107h.096c1.005-1.628 2.538-2.442 4.694-2.442 1.628 0 2.92.526 3.927 1.628 1.006 1.101 1.484 2.73 1.484 4.885v8.956h-4.693v-8.38c0-2.156-.814-3.258-2.395-3.258-1.149 0-1.963.575-2.394 1.724-.096.24-.144.623-.144 1.198v8.716h-4.79V12.398Z' />
);

export const viewBox = '0 0 25 25';
